<template>
    <Head title="Update Brand" />
    <BreezeAuthenticatedLayout>
        <template #header>
            Update Brand - {{ brand.name }}
        </template>
        <BreadCrumbs :items="items"></BreadCrumbs>
        <div class="w-full my-6 overflow-hidden py-12 shadow">
            <div class="px-6 pt-4 pb-2">
                <form enctype="multipart/form-data" @submit.prevent="submit" class="w-full">
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
                        <div class="col-span-2 md:mb-4">
                            <admin-app-label>Name</admin-app-label>
                            <input-basic
                                placeholder="Name"
                                :value="brand.name"
                                :error="errors['name']"
                                disabled="disabled"
                                class="border-grey-100 hover:cursor-not-allowed"
                            />
                            <input-error v-if="errors['name']">
                                {{ errors.name }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mt-6 md:mb-4">
                            <input-checkbox v-model="form.featured">
                                Featured
                            </input-checkbox>
                        </div>
                    </div>
                    <div class="grid grid-cols-2 gap-6">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Image</admin-app-label>
                            <image-upload
                                :key="`Image`"
                                :label="`Image`"
                                v-model="form.image"
                                :error="errors['image']"
                            />
                            <div v-if="brand.image" class="my-4">
                                <admin-app-label>Current Image</admin-app-label>
                                <img class="object-contain p-3 border-solid border-2 border-grey-200 rounded" :src="brand.image" :alt="brand.name" />
                            </div>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Hero Image</admin-app-label>
                            <image-upload
                                :key="`HeroImage`"
                                :label="`Image`"
                                v-model="form.hero_image"
                                :error="errors['hero_image']"
                            />
                            <div v-if="brand.hero_image" class="my-4">
                                <admin-app-label>Current Image</admin-app-label>
                                <img class="object-contain p-3 border-solid border-2 border-grey-200 rounded" :src="brand.hero_image" :alt="brand.name" />
                            </div>
                        </div>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Description</admin-app-label>
                        <input-wysiwyg
                            :value="brand.description"
                            v-model="form.description"
                        ></input-wysiwyg>
                        <input-error v-if="errors['content']">
                            {{ errors.content }}
                        </input-error>
                    </div>
                    <seo-tags v-model="form.seo_tags" :errors="errors"></seo-tags>
                    <app-button type="submit" class="mt-8">Update</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import {Head} from "@inertiajs/inertia-vue3";
import BreezeAuthenticatedLayout from '@/Layouts/Admin/Authenticated.vue'
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import InputError from "@/Components/Forms/Inputs/InputError";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import InputWysiwyg from "@/Components/Admin/Forms/Inputs/InputWysiwyg";
import ImageUpload from "@/Components/Admin/Forms/Inputs/ImageUpload";
import AppButton from "@/Components/AppButton";
import InputCheckbox from "@/Components/Forms/Inputs/InputCheckbox";
import SeoTags from "@/Components/Admin/Forms/SeoTags";

export default {
    name: "Edit",
    components:
        {
            SeoTags,
            InputCheckbox,
            AppButton,
            AdminAppLabel,
            BreadCrumbs,
            Head,
            InputError,
            InputBasic,
            ImageUpload,
            InputWysiwyg,
            BreezeAuthenticatedLayout,
        },
    props: {
        name: String,
        errors: Object,
        brand: Object
    },
    data: function () {
        return {
            items: [
                {title: "Brands", path: "/admin/brands"},
            ],
            form: this.$inertia.form({
                ...this.brand,
                image: null,
                hero_image: null,
                _method: "put"
            })
        };
    },
    mounted() {
        var valueToPush = {};
        valueToPush.title = "#" + this.brand.id;
        valueToPush.path = route("admin.brands.edit", this.brand);

        this.items.push(valueToPush);
    },
    methods: {
        submit()
        {
            this.form.post(route("admin.brands.update", this.brand));
        }
    }
}
</script>

<style scoped>

</style>
